module.exports = __webpack_public_path__ + "img/46200.d6157ed5.jpg";